<!--
  A strip naming the environment. Renders nothing in production.

  Teleported to <body> so it is a sibling of #app rather than a descendant.
  That is load-bearing, not tidiness: index.css puts a hue-rotate filter on #app
  to tint this tier, and a filter makes an element the containing block for its
  position:fixed descendants. Anything fixed inside #app - this banner, .modalOn,
  .navModalOn, #more-sidemenu - is therefore positioned against #app, not the
  window. A banner that lives inside the box it is supposed to sit above ends up
  measured against itself: it drifts down by the offset and scrolls away with the
  page. Outside #app it is also outside #app's stacking context, so nothing in
  the app can paint over it whatever z-index it claims (#more-sidemenu asks for
  10000).

  Paired with the [data-env] overrides in index.css: the tint makes the
  environment obvious at a glance, the banner makes it unambiguous in a
  screenshot or a support ticket. Being outside the filter is a bonus - the strip
  now renders its true amber/violet rather than a hue-rotated version of it.
-->
<template>
  <Teleport v-if="label" to="body">
    <div ref="banner" class="env-banner">{{ label }}</div>
  </Teleport>
</template>

<script>
import { ENVIRONMENT_LABEL } from "@/config/environment";

export default {
  name: "EnvironmentBanner",
  data() {
    return { label: ENVIRONMENT_LABEL, observer: null };
  },
  mounted() {
    if (!this.label) return;
    this.publishHeight();
    this.observer = new ResizeObserver(this.publishHeight);
    if (this.$refs.banner) this.observer.observe(this.$refs.banner);
  },
  beforeUnmount() {
    if (this.observer) this.observer.disconnect();
    this.observer = null;
    document.documentElement.style.removeProperty("--env-banner-h");
  },
  methods: {
    /**
     * Publish the banner's real height as --env-banner-h.
     *
     * The flex column in index.css already reserves the space structurally, so
     * this is not what keeps the banner from covering things. It exists only
     * because vh-100 and the hard-coded 100vh in NavBar/TablePage are viewport
     * units and CSS cannot redefine vh: the rules that turn those into "the app
     * region" subtract this value, and it has to follow the banner when the
     * label wraps to two lines on a narrow screen.
     */
    publishHeight() {
      const height = this.$refs.banner?.offsetHeight;
      if (height) {
        document.documentElement.style.setProperty("--env-banner-h", `${height}px`);
      }
    },
  },
};
</script>
